module.exports = __webpack_public_path__ + "img/chengdu.fa3e0a73.jpg";